import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import StatsCard from './StatsCard';
import PayoutTable from './PayoutTable';
import {
  AttachMoney as EarningsIcon,
  TrendingUp as PayoutIcon,
  CheckCircleOutline as ReceivedIcon,
  AccessTime as RemainingIcon,
} from '@mui/icons-material';

const Payouts = () => {
  return(
    <Box p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Total Earnings"
            value="₹1,25,000.00"
            subtitle="From all policies"
            IconComponent={EarningsIcon}
            // iconColor="text.secondary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Total Payout"
            value="₹1,00,000.00"
            subtitle="Commission earned"
            IconComponent={PayoutIcon}
            // iconColor="text.secondary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Received Payout"
            value="₹75,000.00"
            subtitle="Already received"
            IconComponent={ReceivedIcon}
            iconColor="success.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Remaining Payout"
            value="₹25,000.00"
            subtitle="Pending payment"
            IconComponent={RemainingIcon}
            iconColor="error.main"
          />
        </Grid>
      </Grid>

      <Box mt={4}>
        <Typography variant="h3" gutterBottom>
          Payout Details
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Detailed breakdown of earnings from each policy
        </Typography>
        <PayoutTable />
      </Box>
    </Box>
  )
};

export default Payouts;
